import { render, staticRenderFns } from "./GruposFinanciamento.vue?vue&type=template&id=5e8df974&scoped=true&"
import script from "./GruposFinanciamento.vue?vue&type=script&lang=js&"
export * from "./GruposFinanciamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8df974",
  null
  
)

export default component.exports